// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"925afe57","787":"dbdbece6"}[chunkId] + ".chunk.js";
};